import React from 'react';
import { useSelector } from 'react-redux';
import { RequestBudgetStatus } from '../../model/constants';

const PromotionStatusPopup = () => {
    const { settings } = useSelector(state => state.configurator);

    const getStatusMessage = () => {
        const name = settings?.name;
        const requestBudgetStatus = settings?.request_budget_status;

        switch (requestBudgetStatus) {
            case RequestBudgetStatus.RequestBudgetEnded:
                return `El proceso de formalización para la promoción Bizionar - ${name} ha finalizado.`;

            default:
                return `La herramienta de personalización para la promoción Bizionar - ${name} está inactiva.`;
        }
    };

    return (
      <div className="promotion-status-popup">
        <div className="background" />
        <div className="panel">
          <div className="header">Configurador de Bizionar</div>
          <div className="subheader">{getStatusMessage()}</div>
        </div>
      </div>
    );
};

export default PromotionStatusPopup;
